module.exports = __webpack_public_path__ + "img/MO.79ad37e1.png";